import { env } from 'Constant/env'

const Consts = {
    GrantType: "password",
    RedirectUri: window.location.origin + '/SignInCallback',
    SilentRedirectUri: window.location.origin + '/SilentCallback',
    PostLogoutRedirectUri: window.location.origin + '/SignOutCallback',
    ResponseType: 'code',
    env: env

};

export default Consts;
